import actions from './actions';
import mutations from './mutations';

export default {
  actions,
  mutations,
  namespaced: true,
  state: {
    activeTab: null,      // Control which tab is showing the app
    brands: [],           // All the brands that are in the selected classification
    classification: null, // The selected classification
    classifications: [],  // The list with possible classifications to select
    feature: null,        // The selected feature
    features: [],         // All the features to select
    featureValue: null,   // The value to save as feature for the matching items
    featureValues: [],    // All the distinct values used with the selected feature in the past
    likePattern: {
      like: null,         // The pattern to use with the LIKE operator of sql server
      notLike: null       // The pattern to use with the NOT LIKE operator in sql server
    },
    loadingBrands: false, // Is loading the brands of the selected classification
    loadingClassifications: false,  // The app is loading the classifications
    loadingCreateFeature: false,  // The app is creating a feature
    loadingFeatures: false, // The app is loading the features of the classification
    loadingFeatureValues: false,  // The app is loading all the distinct feature's values
    loadingItems: false,  // Is getting the items from the backend
    loadingRemoveFeature: false, // The app is removing a feature
    loadingRules: false,  // The app is getting the rules created in the past
    loadingSaveRule: false, // The app is saving a rule
    items: [],            // Some of the items that matched the rule
    itemsPagination: {
      descending: false,  // Sort in descending order
      page: 1,            // Start in the first page
      rowsPerPage: 100,   // How many items we must show in the page
      sortBy: "name",     // Sort the items by name
    },
    itemsTotal: null,     // The total number of items that matched the rule
    onlyMissing: true,    // Get only items without the selected feature
    rules: [],            // The rules already created by the selected classification and feature
    rulesPagination: {
      page: 1,
      rowsPerPage: 30,
    },
    rulesTotal: null,     // The number of rules that are for the selected classification and feature
    selectedBrands: [],   // The brands selected by the user to filter the products
    showSidebar: true,    // Show the sidebar with the configurations
  }
}